import { useEffect } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { showToast } from '@/components/ui/Toast';

/**
 * PWA keshni tozalab, ilovani eng so'nggi versiyaga majburiy yangilash.
 * Barcha Service Worker va CacheStorage ma'lumotlarini o'chiradi va yangi versiyani serverdan tortadi.
 */
export async function forceAppUpdate(): Promise<void> {
  try {
    showToast("Ilova yangilanmoqda...", 'info');
    if (typeof window !== 'undefined') {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          await reg.unregister();
        }
      }
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        for (const name of cacheNames) {
          await caches.delete(name);
        }
      }
    }
  } catch (err) {
    console.error('Keshni tozalashda xatolik:', err);
  } finally {
    // Keshni chetlab o'tib, yangi versiyani serverdan tortib olish
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.set('_v', Date.now().toString());
    window.location.replace(cleanUrl.toString());
  }
}

// Konsoldan test qilish uchun window obyektiga ulab qo'yamiz
if (typeof window !== 'undefined') {
  (window as unknown as { forceAppUpdate?: typeof forceAppUpdate }).forceAppUpdate = forceAppUpdate;
}

export function usePwaUpdate(): void {
  useEffect(() => {
    let refreshing = false;

    // Yangi SW aktivlashganda sahifani avtomatik bir marta yangilash
    const handleControllerChange = () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    };

    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    let intervalId: ReturnType<typeof setInterval> | undefined;
    let visibilityHandler: (() => void) | undefined;

    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        void updateSW(true);
      },
      onOfflineReady() {
        // Oflayn rejim tayyor
      },
      onRegisteredSW(_swUrl, registration) {
        if (!registration) return;

        // Har 60 soniyada yangi versiya borligini tekshirish
        intervalId = setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 1000);

        // Foydalanuvchi Telegram MiniApp'ga qaytganda yangilanishni tekshirish
        visibilityHandler = () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
          }
        };
        document.addEventListener('visibilitychange', visibilityHandler);
      },
    });

    return () => {
      if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
      if (intervalId) clearInterval(intervalId);
      if (visibilityHandler) document.removeEventListener('visibilitychange', visibilityHandler);
    };
  }, []);
}
